import React from "react";
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';

function importAll(r) {
    let images = {};
    r.keys().map(item => (
        images[item.replace('./', '')] = r(item) 
    ));
    return images;
}
const images = importAll(require.context('../../Assets', false, /\.(png|jpe?g|svg)$/));

const carsCollection = ['Car2', 'Car3', 'Car5', 'Car6', 'Car7']

export function CarLists () {
    return (
        <>
        <h4 className="my-3 text-white text-center">Our Cars</h4>
            <Container fluid='xl' style={{minHeight : '50vh'}} className='d-flex flex-wrap justify-content-center'>
            {carsCollection.map(e => 
                <Card key={e} style={{ width: '18rem' }} className='m-2'>
                    <Card.Img variant="top" src={images[`${e}.png`]} />
                </Card>
            )}
            </Container>
        </>
    )
}